import GrowthInvitationsComponent from '../Components/Growth/GrowthInvitationsComponent';

function GrowthInvitationsPage() {
  return <GrowthInvitationsComponent />;
}

export default GrowthInvitationsPage;